/* global Liferay */

import React, { useState } from "react";
import { useModal } from "@clayui/modal";

import ChatModal from "./ChatModal";

const ChatButton = () => {
  const [openChatModal, setOpenChatModal] = useState(false);

  const { observer, onClose } = useModal({
    onClose: () => setOpenChatModal(false),
  });

  return (

   <>
      <button
        className="message d-flex align-items-center"
        onClick={() => setOpenChatModal(!openChatModal)}
      >
          <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M25.6 4H6.4C5.08 4 4 5.08 4 6.4V28L8.8 23.2H25.6C26.92 23.2 28 22.12 28 20.8V6.4C28 5.08 26.92 4 25.6 4ZM25.6 20.8H8.8L6.4 23.2V6.4H25.6V20.8Z" fill="#002F70"></path>
         </svg> 
         <span class="customChatStyle d-none d-lg-block">{Liferay.Language.get("chat-app")}</span>
      </button>
      {openChatModal && <ChatModal observer={observer} onClose={onClose} />}
   </>
  );
};

export default ChatButton;
